// src/pages/CustomerList.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import {
  Container, Paper, Typography, Button, Table, TableHead, TableRow,
  TableCell, TableBody, IconButton, Box, CircularProgress
} from "@mui/material";
import {
  Delete as DeleteIcon, Edit as EditIcon, PersonAdd as PersonAddIcon,
  Groups as GroupsIcon, FileDownload as DownloadIcon
} from "@mui/icons-material";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function CustomerList() {
  const navigate = useNavigate();
  const companyId = localStorage.getItem('companyId');
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    axios.get(`/Customer/by-company/${companyId}`)
      .then(res => setCustomers(res.data))
      .catch(err => console.error('❌ خطأ في تحميل العملاء:', err))
      .finally(() => setLoading(false));
  }, [companyId]);

  const deleteCustomer = id => {
    if (!window.confirm('❗ هل أنت متأكد من حذف هذا العميل؟')) return;
    axios.delete(`/Customer/${id}`)
      .then(() => {
        setCustomers(cs => cs.filter(c => c.id !== id));
        alert('🗑️ تم حذف العميل');
      })
      .catch(() => alert('❌ حدث خطأ أثناء الحذف'));
  };

  const exportToExcel = () => {
    const data = customers.map((c, idx) => ({
      'رقم': idx + 1, 'الاسم': c.name || c.Name, 'الرقم الضريبي': c.taxNumber || c.TaxNumber || '-', 'الجوال': c.mobile || c.Mobile || '-'
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'العملاء');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), "customers.xlsx");
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        mt: 5,
        mb: 5,
        px: { xs: 2, md: 4 },
      }}
      dir="rtl"
    >
      {/* هيدر تدرج النصوص الفاخر العصري مطابق لباقي الشاشات */}
      <Box sx={{ mb: 6, textAlign: { xs: 'center', md: 'start' }, display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 3, md: 2 } }}>
        <Box sx={{ textAlign: { xs: 'center', md: 'start' } }}>
          <Typography
            variant="h3"
            sx={{
              background: 'linear-gradient(90deg, #4F46E5 0%, #10B981 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              letterSpacing: '-0.5px',
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              justifyContent: { xs: 'center', md: 'flex-start' }
            }}
          >
            <GroupsIcon sx={{ fontSize: 40 }} />
            إدارة العملاء
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight={600}>
          
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="outlined" onClick={exportToExcel} sx={{ borderColor: '#cbd5e1', borderRadius: '12px', color: '#334155', fontWeight: 700, px: 2.5, borderWidth: '1.5px', '&:hover': { bgcolor: '#f8fafc', borderColor: '#94a3b8' } }} startIcon={<DownloadIcon />}>تصدير Excel</Button>
          <Button variant="contained" onClick={() => navigate('/customers/new')} sx={{ bgcolor: '#4F46E5', borderRadius: '12px', fontWeight: 800, px: 3, boxShadow: '0 10px 25px -10px rgba(79, 70, 229, 0.5)', '&:hover': { bgcolor: '#4338CA' } }} startIcon={<PersonAddIcon />}>إضافة عميل جديد</Button>
        </Box>
      </Box>

      {/* جدول البيانات */}
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', border: '1px solid #e2e8f0', overflowX: 'auto' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={5}><CircularProgress /></Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                {['#', 'الاسم', 'الرقم الضريبي', 'الجوال', 'إجراءات'].map(h => <TableCell key={h} align="center" sx={{ fontWeight: 'bold' }}>{h}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((c, idx) => (
                <TableRow key={c.id || c.Id}>
                  <TableCell align="center">{idx + 1}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>{c.name || c.Name}</TableCell>
                  <TableCell align="center">{c.taxNumber || c.TaxNumber || '-'}</TableCell>
                  <TableCell align="center">{c.mobile || c.Mobile || '-'}</TableCell>
                  <TableCell align="center">
                    <IconButton color="warning" onClick={() => navigate(`/customers/${c.id || c.Id}/edit`)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => deleteCustomer(c.id || c.Id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {customers.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4 }}>لا يوجد بيانات لعرضها</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Container>
  );
}